import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'rsuite';
import DownloadPdf from '../DownloadPdf';

const PrintPdfButton = ({ label, fileName, content, callback, ...props }) => {
  const [executePrint, setExecutePrint] = useState(false);
  const handlePrint = () => {
    setExecutePrint(true);
    callback();
  };

  return !executePrint ? (
    <Button {...props} onClick={handlePrint}>
      <Icon icon="print" /> {label}
    </Button>
  ) : (
    <DownloadPdf fileName={fileName} content={content} label={label} />
  );
};

PrintPdfButton.propTypes = {
  label: PropTypes.string,
  content: PropTypes.node.isRequired,
  fileName: PropTypes.string.isRequired,
  callback: PropTypes.func
};

PrintPdfButton.defaultProps = {
  label: 'Print',
  callback: () => {}
};

export default PrintPdfButton;
